import styled , {css} from 'styled-components';
import * as C from '../../../components/loggedout/shared-styles/Colors';
import { device } from '../../../utils/responsive_utilities';

export const BackgroundContainer = styled.div`
  height: ${props=> props.screenH || window.innerHeight}px;
  overflow: hidden;
  background-color: ${C.deepCoveDark};
  position: relative;
`;

export const ElementWrap = styled.div`
  position: absolute;
  top: ${props => `${props.initPos.Y}%`};
  ${props => props.initPos.placement === 'left' ? 
    css`
      left: ${props.initPos.X + '%'};
      transform: translate(-50%, -50%) rotate(${props.initPos.deg + 'deg'});
      @media ${device.Phone} {
        transform: translate(-50%, -50%) scale(0.3) rotate(${props.initPos.deg + 'deg'});
      }
      @media ${device.PhoneTabletLandscape} {
        transform: translate(-50%, -50%) scale(0.4) rotate(${props.initPos.deg + 'deg'});
      }
      @media ${device.Tablet}{
        transform: translate(-50%, -50%) scale(0.7) rotate(${props.initPos.deg + 'deg'});
      }
      @media ${device.TabletLandscape}{
        transform: translate(-50%, -50%) scale(0.8) rotate(${props.initPos.deg + 'deg'});
      }
    ` : 
    css`
      right: ${props.initPos.X + '%'};
      transform: translate(50%, -50%) rotate(${props.initPos.deg + 'deg'});
      @media ${device.Phone} {
        transform: translate(50%, -50%) scale(0.3) rotate(${props.initPos.deg + 'deg'});
      }
      @media ${device.PhoneTabletLandscape} {
        transform: translate(50%, -50%) scale(0.4) rotate(${props.initPos.deg + 'deg'});
      }
      @media ${device.Tablet}, ${device.TabletLandscape}{
        transform: translate(50%, -50%) scale(0.8) rotate(${props.initPos.deg + 'deg'});
      }
    `
  }
  transition: ease-out all 1s;
`